var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppView',{staticClass:"flex-center full-height stepper",attrs:{"id":"authenticate"}},[_c('transition',{attrs:{"name":_vm.transition,"mode":"out-in"}},[_c(_vm.views[_vm.step],{tag:"component",attrs:{"error":_vm.error,"_viewData":_vm.viewData},on:{"next":_vm.next,"previous":_vm.previous,"error":_vm.errorHandler}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }